import { ToasterPositionEnum } from '@shared/enums';
import { Message } from 'primeng/api';

export class ToasterHelper {
    static error(
        message: string = "Something didn't quite go as planned. Please try again later.",
        title: string = 'Error'
    ): Message {
        return {
            key: ToasterPositionEnum.TOP_CENTER,
            severity: 'error',
            summary: title,
            detail: message,
            icon: 'pi-minus-circle',
        };
    }

    static warning(message: string, title: string = 'Warning'): Message {
        return {
            key: ToasterPositionEnum.TOP_CENTER,
            severity: 'warn',
            summary: title,
            detail: message,
            icon: 'pi-exclamation-triangle',
        };
    }

    static success(message: string, title: string = 'Success'): Message {
        return {
            key: ToasterPositionEnum.BOTTOM_RIGHT,
            severity: 'success',
            summary: title,
            detail: message,
            icon: 'pi-check-square',
        };
    }

    static info(message: string, title: string = 'Info'): Message {
        return {
            key: ToasterPositionEnum.BOTTOM_RIGHT,
            severity: 'info',
            summary: title,
            detail: message,
            icon: 'pi-exclamation-circle',
        };
    }
}
